module.exports = __webpack_public_path__ + "img/connect-subdomain-dark.4de8eddf.svg";